import { NO_LABEL, UNSURE_LABEL, YES_LABEL } from "config/LabelMapping";
import { DetectorModes } from "types/createDetector";
import { ANSWER_VALUES } from "types/imageQueries";
import { LabelValue } from "types/labelValue";

/**
 * Maps the the given label value to the answer value to render in canvas.
 */
export function getFrontendLabelValueFromBackendLabel(labelSelected: LabelValue, detectorMode: DetectorModes): string {
  const labelSelectedValue =
    typeof labelSelected?.answer === "string" ? labelSelected.answer : labelSelected?.answer.value;

  if (detectorMode === DetectorModes.COUNT || detectorMode === DetectorModes.TEXT_RECOGNITION) {
    // For the case of UNCLEAR the label value will be `null` so the class name
    // is used to validate is really unclear
    if (labelSelected.class_name === UNSURE_LABEL) {
      return ANSWER_VALUES.UNCLEAR;
    }
  }

  // Mapping backend YES and NO labels to the frontend answer value
  if (detectorMode === DetectorModes.BINARY) {
    if (labelSelectedValue === YES_LABEL) {
      return ANSWER_VALUES.YES;
    }

    if (labelSelectedValue === NO_LABEL) {
      return ANSWER_VALUES.NO;
    }
  }

  if (detectorMode === DetectorModes.TEXT_RECOGNITION) {
    // For the case of sending `text no present`
    if (labelSelectedValue === null) {
      return "";
    }
  }

  return String(labelSelectedValue);
}
